export enum EZoneUsage {
    PreWork = 1,
    Environmental = 2,
    PostWork = 3,
}